<template>
    <div class="button">
        <span class="item" @click="btnclick">修改</span>
        <span class="item" @click="btnclick">修改</span>
    </div>
    
</template>

<script>
export default({
    name:'clipButton',
    methods:{
        btnclick() {
            this.$emit('clipClick');
        }
    }
})
</script>

<style lang="scss" scoped>
    .button{
        cursor: pointer;
        position: relative;
        width: 100px;
        height: 30px;
        .item{
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            display: inline-block;
            background: #5a77d4;
            color: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
            text-transform: uppercase;
            font-size: 18px;
        }
        span:nth-child(2) {
            color: #fff;
            background: rgb(241, 145, 66);
            overflow: hidden;
            z-index: 2;
            transition: 0.5s;
            clip-path: polygon(59% 1%, 100% 0%, 100% 100%, 60% 100%, 40% 51%);
        }
        span:nth-child(2):hover {
            clip-path: polygon(0 0, 100% 0%, 100% 100%, 0 100%, 0 54%);
        }

        span:nth-child(1):hover ~  span:nth-child(2) {
            clip-path: polygon(100% 0, 100% 0%, 100% 100%, 100% 100%, 100% 52%);
        }
    }
</style>